const home = {
  head: [
    {
      title: "交易",
      url: "https://swap.transit.finance?locale=zh",
    },
    {
      title: "NFT",
      list: [
        {
          title: "NFT Design Competition",
          // url: "https://tp-lab.tokenpocket.pro/mint-skin/index.html#/",
          url: "https://tp-lab.tokenpocket.pro/mint-skin-2/index.html#/",
          icon: require("../../assets/mobile/header/nft_design.png"),
        },
        {
          title: "Transit NFT",
          url: "https://nft.transit.finance/#/",
          icon: require("../../assets/mobile/header/transit_nft.png"),
        },
        {
          title: "NFT MarketPlace",
          url: "https://nft.transit.finance/waitlist/#/",
          icon: require("../../assets/pc/header/NFT_Marketplace.png"),
        },
      ],
    },
    {
      title: "下载 TP",
      url: "https://tp.transit.finance/zh/download/app",
    },
    {
      title: "治理",
      list: [
        {
          title: "治理",
          desc: "抵押TPT，换取xTPT，参与治理，投出你的一票",
          url: "/zh/stake/",
          icon: require("../../assets/mobile/header/dao.png"),
          // soon: '即将上线',
          type: "route",
        },
        {
          title: "捐赠",
          desc: "向 Transit Swap 进行无偿捐赠，以推动Transit Swap进行更好的运营。",
          url: "/zh/donation/",
          icon: require("../../assets/mobile/header/donate.png"),
          type: "route",
        },
        {
          title: "费率",
          desc: "持有TPT或xTPT可额外获得交易手续费折扣",
          url: "/zh/fee/",
          icon: require("../../assets/mobile/header/fee.png"),
          type: "route",
        },
      ],
    },
    {
      title: "社区",
      list: [
        {
          title: "Transit Swap 论坛",
          desc: "",
          url: "https://fans.tokenpocket.pro/c/xswap-announcement-xswap/14",
          icon: require("../../assets/mobile/header/community.png"),
        },
        {
          title: "Twitter",
          desc: "",
          url: "https://twitter.com/TransitFinance",
          icon: require("../../assets/mobile/header/governance.png"),
        },
        {
          title: "帮助中心",
          desc: "",
          url: "https://docs.transit.finance/cn/",
          icon: require("../../assets/mobile/header/docs.png"),
        },
      ],
    },
    {
      title: "购买加密资产",
      // url: 'https://www.transit.finance/openc/index.html?widgetId=UjcyR3hQVlk',
      url: "https://openc.pro/widget-page/?widgetId=UjcyR3hQVlk",
    },
  ],
  launchApp: "启动App",
  introduction: {
    desc: "全新的去中心化交易体验，更好的流动性带来更多的收益，万链聚集于Transit Swap中",
    start: "开始交易",
  },
  section1: {
    desc: "Transit Swap集成了绝大多数公链受用户喜爱的DEX，我们选取了他们的优势并智能地结合在一起，为您的交易提供更好的深度，返回更多的目标token。使用Transit Swap，让您不必再担心什么DEX可以交易，什么DEX的深度更好，您只需要记得，交易就选择Transit Swap。",
    advantage: [
      {
        icon: require("../../assets/pc/section1/chains.png"),
        desc: "多链交易，无须为选择而烦恼",
      },
      {
        icon: require("../../assets/pc/section1/polymerization.png"),
        desc: "聚齐优势，汇聚一身，让深度更深，让价格更美好",
      },
      {
        icon: require("../../assets/pc/section1/bridge.png"),
        desc: "资产跨链，安全，简单",
      },
      {
        icon: require("../../assets/pc/section1/safe.png"),
        desc: "一次授权，多处使用，让交易更安全",
      },
    ],
  },
  section2: {
    desc: "多种策略，智能选择交易路径，交易不再单一方向，比人更会“货”比三家，提供最好的交易价格！",
  },
  section3: {
    desc: "聚合多种跨链方式，让您的资产在多个链之间轻松转移，让跨链不再成为您的烦恼。",
  },
  end: {
    start: "开始交易",
  },
  foot: {
    info: [
      // {
      //     title: '隐私政策',
      //     url: 'https://www.baidu.com',
      // },
      {
        title: "用户协议",
        url: "https://tp-lab.tokenpocket.pro/TransitSwapUserAgreement/index.html?locale=zh#/",
      },
    ],
    language: "English",
    media: {
      mailUrl: "service@transit.finance",
      codeCatUrl: "https://github.com/transit-finance",
      twitterUrl: "https://twitter.com/TransitFinance",
      mUrl: "https://fans.tokenpocket.pro/c/xswap-announcement-xswap/14",
      tgUrl: "https://t.me/Transit_Finance",
    },
    copyright: "Transit Swap@2021, All Rights Reserved",
  },
  donation: {
    know: {
      title: "Transit Swap捐赠池定义：",
      desc: "作为开放的区块链世界的一份子，Transit Swap项目接受来自个人用户的Token捐赠，所有捐赠将进入捐赠池，池内资金将用于包括但不限于Transit Swap项目运营与对Transit Swap相关生态的资助。",
    },
    tip: {
      title: "重要提示：",
      desc: "Transit Swap项目不会对捐赠者有确定性的回报与奖励；在捐赠哈希72小时内，希望退回捐赠的捐赠者可通过官方联系方式提出原路返还要求，超过这一时限的返还要求将不被处理。",
    },
    donateType: {
      title: "我们接受的捐赠代币种类：",
      desc: "TPT",
    },
    address: {
      title: "接受捐赠的地址：",
    },
    join: "参与捐赠",
    donateChain: "选择捐赠的链",
    connectWallet: "连接钱包",
    donateTip: {
      title: "注：",
      desc: "在捐赠哈希72小时内，希望退回捐赠的捐赠者可通过官方联系方式提出原路返还要求，超过这一时限的返还要求将不被处理。",
    },
    warn: "请先选择捐赠的链",
    transfer: "请使用TokenPocket扫描该二维码进行TPT捐赠",
    copyAddress: "复制地址",
    copied: "复制成功",
    yourAddress: "您的地址",
    cantDonate: "当前链不支持捐赠",
    confirmDonate: "确定捐赠",
    donateSuccess: "捐赠成功",
    donateFail: "捐赠失败",
    overCount: "余额不足",
    donateAddress: "捐赠地址",
    donateCount: "捐赠数量 (TPT)",
    pleaseSwitch1: "请切换到",
    pleaseSwitch2: "网络",
    downloadTP: "无法直接捐赠，请下载TokenPocket钱包",
    connectTronLink: "请先连接TronLink钱包",
    waitBlockConfirm: "提交成功",
    noZero: "捐赠数量不能为0",
  },

  stake: {
    know: {
      title: "抵押 TPT 获得 xTPT",
      desc: "抵押 TPT 获得 xTPT, xTPT 可以用于生态提案的投票。 你可以随时兑换TPT 与 xTPT，目前仅支持BSC链的TPT。 更多链陆续上线中...",
    },
    join: "已抵押 TPT",
    connectWallet: "连接钱包",
    networkNotvalid: "请切换到BSC网络",
    approve: "授权",
    unstake: "解押",
    add: "增加",
    loginFirst: "请先连接钱包",
    deposit: "抵押 TPT",
    withdraw: "解押 TPT",
    balance: "余额",
    confirm: "确认",
    overbalance: "超过可用余额",
    success: "操作成功",
    all: "全部",
    voteTip: "使用 xTPT 来投票你支持的提案!",
    goVote: "去投票",
  },
  fee: {
    desc: "Transit Swap上线聚合交易手续费折扣功能，根据用户账户地址持有的TPT与xTPT数量的总和对应的折扣率进行手续费折扣。当前折扣等级分为4级，将来根据实际情况，进行更多层级拆分。",
    feeDiscount: "费率折扣",
    walletBalance: "钱包余额",
    levelRank: "等级",
    levelBalance: "余额（TPT及xTPT)",
    levelDiscountRate: "折扣率",
    level: [
      {
        rank: "LV.1",
        icon: require("../../assets/pc/fee/lv1.png"),
        balance: "≥10,000",
        discountRate: "10%",
      },
      {
        rank: "LV.2",
        icon: require("../../assets/pc/fee/lv2.png"),
        balance: "≥100,000",
        discountRate: "20%",
      },
      {
        rank: "LV.3",
        icon: require("../../assets/pc/fee/lv3.png"),
        balance: "≥1,000,000",
        discountRate: "40%",
      },
      {
        rank: "LV.4",
        icon: require("../../assets/pc/fee/lv4.png"),
        balance: "≥10,000,000",
        discountRate: "70%",
      },
    ],
  },
  warn: {
    content:
      '<span class="bold">Xswap</span> 品牌升级公告：“<span class="bold">Xswap</span>”现已正式更名为 “<span class="bold">Transit Swap</span>”',
    url: "https://medium.com/@TransitSwap/xswap-announced-rebranding-brand-name-officially-upgraded-to-transit-swap-52c4c11672ec",
    text: "前往了解",
  },
  modal: {
    desc1: "Transit 客服不会私聊您！",
    desc2:
      "请注意，您即将进入Transit社区，您进入社区可能会有人假冒Transit的工作人员私聊您，请您务必警惕，所有私聊您的都可能是骗子！Transit工作人员不会主动跟您私信！",
    desc3: "知道了，继续前往",
  },
};
export default home;
